import { render, staticRenderFns } from "./HQApproval.vue?vue&type=template&id=8e835e46&scoped=true"
import script from "./HQApproval.vue?vue&type=script&lang=js"
export * from "./HQApproval.vue?vue&type=script&lang=js"
import style0 from "./HQApproval.vue?vue&type=style&index=0&id=8e835e46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e835e46",
  null
  
)

export default component.exports